export class AzureEntraIdRestoreEntity {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "entityId",
            "baseName": "entityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "DirectoryEntityType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureEntraIdRestoreEntity.attributeTypeMap;
    }
    constructor() {
    }
}
